function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ModalSidebar from "./ModalSidebar";
import LoadingAnimation from "../loadinganimation/LoadingAnimation";
import { Context } from "./Modal";
const ModalBody = ({
  padded,
  ...props
}) => {
  const context = useContext(Context);
  const childrenFromProps = React.Children.toArray(props.children);
  const hasPanel = childrenFromProps.length > 0 && Object.is(childrenFromProps[0].type, ModalSidebar);
  const children = hasPanel ? [childrenFromProps[0], /*#__PURE__*/React.createElement("div", {
    key: "tui-modal-side-content",
    className: `tui-modal-side-content ${padded ? "padded" : ""}`
  }, ...childrenFromProps.slice(1, childrenFromProps.length))] : props.children;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classNames("tui-modal-content", {
      "has-panel": hasPanel,
      [props.className]: props.className,
      padded
    })
  }), children, (context.isLoading || context.isSubmitting) && /*#__PURE__*/React.createElement("div", {
    className: "loader-overlay"
  }, /*#__PURE__*/React.createElement(LoadingAnimation, null)));
};
ModalBody.displayName = "ModalBody";
ModalBody.defaultProps = {
  style: {},
  className: "",
  children: undefined,
  padded: true
};
ModalBody.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  padded: PropTypes.bool
};
export default ModalBody;
//# sourceMappingURL=ModalBody.js.map